const Config: { apiHost: string } = {
    apiHost: "https://finanz-api.marco83.com"
    //apiHost: "http://localhost:8080"
}

Object.freeze(Config)
export default Config
